// extracted by mini-css-extract-plugin
export default {"redactText":"redactText--d2e5972af16ff1256520","image":"image--daa50d1f73877ebaeb4e","modal":"modal--b6c07180a2a2e944be2d"};